import script from "./CartItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CartItem.vue?vue&type=script&setup=true&lang=js"

import "./CartItem.vue?vue&type=style&index=0&id=47e34f1a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e34f1a"]])

export default __exports__